module.exports = __webpack_public_path__ + "img/logo-dark@2x.54868700.png";